import { IApplicationState } from '../../types/redux';

export const selectId = (state: IApplicationState) => state.legalCheck.id;
